import LoginComponent from "@screens/login/login.component";
import ForgotPasswordComponent from "@screens/forgot-password/forgot-password.component";
import DashboardComponent from "@screens/dashboard/dashboard.component";

import blockedIpRoutes from "./blocked-ip.routes";
import databaseBackupRoutes from "./database-backup.routes";
import emailTemplateRoutes from "./email-template.routes";
import menuItemsRoutes from "./menu-items.routes";
import modulesRoutes from "./modules.routes";
import notificationRoutes from "./notification.routes";
import rolesRoutes from "./roles.routes";
import sentEmailRoutes from "./sent-email.routes";
import sentSmsRoutes from "./sent-sms.routes";
import settingRoutes from "./setting.routes";
import smsTemplateRoutes from "./sms-template.routes";
import userLogRoutes from "./user-log.routes";
import usersRoutes from "./users.routes";
import bugTrackerRoutes from "./bug-tracker.routes";
import versionRoutes from "./version.route";
import adminModuleRoutes from "./admin-module.routes";
import inventoryCategoryRoutes from "./inventory-category.routes";
import inventoryItemsRoutes from "./inventory-items.routes";
import inventoryFileUploadRoutes from "./inventory-file-uploads.routes";
import RefreshPasswordComponent from "@screens/refresh-password/refresh-password.component";
import customersRoutes from "./customers.routes";
import inventoryManufacturersRoutes from "./inventory-manufacturers.routes";
import promoCodeRoutes from "./promo-code.routes";
import productsRoutes from "./products.routes";
import bannersRoutes from "./banners.routes";
import ordersRoutes from "./orders.routes";
import siteSettingsRoutes from "./site-settings.routes";  
import pagesRoutes from "./pages.routes";  


const index = [
  {
    name: "Login",
    path: "/",
    component: <LoginComponent />,
  },
  {
    name: "Forgot Password",
    path: "/forgot-password",
    component: <ForgotPasswordComponent />,
  },
  {
    name: "Refresh Password",
    path: "/refresh-password",
    component: <RefreshPasswordComponent />,
  },
];

export const appRoutes = [
  {
    name: "Dashboard",
    icon: "database",
    path: "/dashboard",
    component: DashboardComponent,
  },
  ...settingRoutes,
  ...menuItemsRoutes,
  ...emailTemplateRoutes,
  ...blockedIpRoutes,
  ...smsTemplateRoutes,
  ...rolesRoutes,
  ...usersRoutes,
  ...userLogRoutes,
  ...sentEmailRoutes,
  ...sentSmsRoutes,
  ...modulesRoutes,
  ...notificationRoutes,
  ...databaseBackupRoutes,
  ...bugTrackerRoutes,
  ...versionRoutes,
  ...adminModuleRoutes,
  ...inventoryCategoryRoutes,
  ...inventoryItemsRoutes,
  ...inventoryFileUploadRoutes,
  ...customersRoutes,
  ...inventoryManufacturersRoutes,
  ...promoCodeRoutes,
  ...productsRoutes,
  ...bannersRoutes,
  ...ordersRoutes,
  ...siteSettingsRoutes,
  ...pagesRoutes,
];

export default index;
